import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioConversor } from '../../conversao';
import { NegocioOportunidadeSearch } from '../negocio-oportunidade-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioOportunidadeConversaoHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negociooportunidade`;
    }

    /** Realiza a conversão de uma qualificação de negócio */
    converter(conversor: NegocioConversor): Observable<NegocioOportunidadeSearch> {
        return this.customHttp.put<NegocioOportunidadeSearch>(`${this.pathApi}/${conversor.idNegocio}/converter`, conversor);
    }
}
